<template>
  <div class="row stats-row" style="margin-left: 15px;">
    <div class="col-xl-3 col-sm-6 mb-3">
      <div class="mb-0 card stat-card">
        <div class="p-3 card-body">
          <div class="d-flex">
            <div>
              <div class="icon icon-shape text-center bg-gradient-info border-radius-2xl">
                <i class="text-xl opacity-10 fa fa-users" aria-hidden="true"></i>
              </div>
            </div>
            <div class="ms-3">
              <div class="numbers">
                <p class="mb-0 text-uppercase font-weight-bold" style="font-size: 13px">
                  <!-- kept intentionally empty to match other cards spacing -->
                </p>
                <h6 class="mb-0 font-weight-bolder">
                  <span class="me-3 d-inline-block text-nowrap">
                    <small style="display:block; opacity:0.65">{{ $t("classroom_stats.boys") }}</small>
                    {{ stats.gender_loading ? "…" : formatNumber(stats.boys) }}
                    <span class="text-xs d-block" style="opacity:0.6" v-if="!stats.gender_loading">
                      {{ share(stats.boys) }}</span>
                  </span>
                  <span class="d-inline-block text-nowrap">
                    <small style="display:block; opacity:0.65">{{ $t("classroom_stats.girls") }}</small>
                    {{ stats.gender_loading ? "…" : formatNumber(stats.girls) }}
                    <span class="text-xs d-block" style="opacity:0.6" v-if="!stats.gender_loading">
                      {{ share(stats.girls) }}</span>
                  </span>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-sm-6 mb-3">
      <div class="mb-0 card stat-card">
        <div class="p-3 card-body">
          <div class="d-flex">
            <div>
              <div class="icon icon-shape text-center bg-gradient-warning border-radius-2xl">
                <i class="text-xl opacity-10 fa fa-hourglass-half" aria-hidden="true"></i>
              </div>
            </div>
            <div class="ms-3">
              <div class="numbers">
                <p class="mb-0 text-uppercase font-weight-bold" style="font-size: 13px">
                  {{ $t("classroom_stats.pending_amount") }}
                </p>
                <h6 class="mb-0 font-weight-bolder">
                  {{ currency_code }} {{ formatNumber(stats.pending_amount) }}
                </h6>
                <span class="text-xs" style="opacity: 0.6">{{ $t("classroom_stats.pending_hint") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-sm-6 mb-3">
      <div class="mb-0 card stat-card">
        <div class="p-3 card-body">
          <div class="d-flex">
            <div>
              <div class="icon icon-shape text-center bg-gradient-success border-radius-2xl">
                <i class="text-xl opacity-10 fa fa-check-circle" aria-hidden="true"></i>
              </div>
            </div>
            <div class="ms-3">
              <div class="numbers">
                <p class="mb-0 text-uppercase font-weight-bold" style="font-size: 13px">
                  {{ $t("classroom_stats.paid_amount") }}
                </p>
                <h6 class="mb-0 font-weight-bolder">
                  {{ currency_code }} {{ formatNumber(stats.paid_amount) }}
                </h6>
                <span class="text-xs" style="opacity: 0.6">{{ $t("classroom_stats.paid_hint") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-sm-6 mb-3">
      <div class="mb-0 card stat-card">
        <div class="p-3 card-body">
          <div class="d-flex">
            <div>
              <div class="icon icon-shape text-center bg-gradient-danger border-radius-2xl">
                <i class="text-xl opacity-10 fa fa-exclamation-triangle" aria-hidden="true"></i>
              </div>
            </div>
            <div class="ms-3">
              <div class="numbers">
                <p class="mb-0 text-uppercase font-weight-bold" style="font-size: 13px">
                  {{ $t("classroom_stats.overdue") }}
                </p>
                <h6 class="mb-0 font-weight-bolder">{{ formatNumber(stats.overdue) }}</h6>
                <span class="text-xs" style="opacity: 0.6">{{ $t("classroom_stats.overdue_hint") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { classroomStats } from "@/utils/classroomStats";
import api_config from "@/config";

export default {
  name: "classroom-stats",
  data() {
    return {
      currency_code: api_config.CURRENCY_CODE,
    };
  },
  computed: {
    stats() {
      return classroomStats;
    },
  },
  methods: {
    formatNumber(value) {
      const locale = this.$i18n.locale === "fr" ? "fr-FR" : "en-US";
      return Number(value || 0).toLocaleString(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    share(value) {
      // Le pourcentage garçon/fille doit toujours être calculé sur le total
      // des élèves dont le genre est compté, c'est-à-dire M + F.
      const total = this.stats.boys + this.stats.girls;
      if (!total) return "0 %";
      return `${Math.round((value / total) * 100)} %`;
    },
  },
};
</script>

<style scoped>
.stat-card {
  min-height: 100px;
}

.stat-card .icon {
  width: 48px;
  height: 48px;
 
}

.mt-3 {
    margin-top: 1rem !important;
    margin-left: 15px !important;
}

</style>
